import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 6.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-0"}],["path",{"d":"M4 17.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-1"}],["path",{"d":"M8.5 15.5l7 -7","key":"svg-2"}]]

const IconConnection = createReactComponent('outline', 'connection', 'Connection', __iconNode);

export default IconConnection;